import { render, staticRenderFns } from "./shops.vue?vue&type=template&id=74b0a5ca&scoped=true"
import script from "./shops.vue?vue&type=script&lang=js"
export * from "./shops.vue?vue&type=script&lang=js"
import style0 from "./shops.vue?vue&type=style&index=0&id=74b0a5ca&prod&lang=less&scoped=true"
import style1 from "./shops.vue?vue&type=style&index=1&id=74b0a5ca&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b0a5ca",
  null
  
)

export default component.exports